<template>
    <tr
        class="lam-section-title"
    >
        <td>
            <div :class="{'uk-text-required': missing_info}" class="uk-flex lam-phase-title">
                <div
                    v-if="!active_project && editable && !!record && (record.scope_id !== null)"
                    class="lam-drag-handle uk-margin-small-right"
                >
                    <open-icon glyph="arrows-v" />
                </div>
                <div class="uk-flex-item-none uk-margin-small-right">
                    <base-button
                        :class="{'uk-active': !!record.starred}"
                        flavor="link"
                        :disabled="!editable"
                        size="mini"
                        @click.prevent="star_toggle"
                    >
                        <open-icon
                            :glyph="!!record.starred ? 'star' : 'star-o'"
                            :class="{ 'uk-text-danger': !!record.starred }"
                        />
                    </base-button>
                </div>
                <div class="uk-flex-item-none uk-margin-small-right">
                    <open-icon v-if="missing_info" glyph="exclamation-triangle" />
                </div>
                <div class="uk-flex-item-1 lam-phase-title-field-container">
                    <phase-title
                        :record="record"
                        :editable="editable"
                    />
                </div>
                <div>
                    <base-button
                        v-if="active_project_editable"
                        color="danger"
                        size="mini"
                        class="uk-margin-left"
                        @click.prevent="remove"
                    >
                        <open-icon glyph="trash" />
                    </base-button>
                </div>
            </div>
        </td>
        <td>
            <div class="uk-flex uk-flex-center uk-flex-middle">
                <form-date-input
                    :id="`phase-${record.starts_at}-starts_at`"
                    v-model="record.starts_at"
                    name="starts_at"
                    :editable="editable"
                    :required="true"
                    :error="has_error('starts_at')"
                    align="center"
                    @input="save_field"
                    class="uk-flex-item-none"
                />
                <span class="uk-flex-item-none uk-form-controls-text uk-margin-left uk-margin-right">
                to
                </span>
                <form-date-input
                    :id="`phase-${record.starts_at}-ends_at`"
                    v-model="record.ends_at"
                    name="ends_at"
                    :editable="editable"
                    :required="true"
                    :error="has_error('ends_at')"
                    align="center"
                    @input="save_field"
                    class="uk-flex-item-none"
                />
            </div>
        </td>
        <td class="uk-text-right">
            <form-input
                :id="`phase-${record.starts_at}-fee`"
                :value="active_project ? record.fee : record.prospective_fee"
                type="float"
                :name="active_project ? 'fee' : 'prospective_fee'"
                glyph="dollar"
                :required="false"
                :editable="editable"
                width="3-10"
                align="right"
                @input="save_field"
            >
                <template v-slot:read_only>
                    ${{ (active_project ? record.fee : record.prospective_fee) | nibnut.number("0,0.00") }}
                </template>
            </form-input>
        </td>
    </tr>
</template>

<script type="text/javascript">
import profile_utilities from "../../../mixins/ProfileUtilities"
import phase_utilities from "../../../mixins/PhaseUtilities"
import handles_saving from "../../../mixins/HandlesSaving"

import PhaseTitle from "../ui/PhaseTitle"
import FormDateInput from "../../../ui/FormDateInput"
import FormInput from "../../../ui/FormInput"
import BaseButton from "../../../ui/BaseButton"
import OpenIcon from "../../../ui/OpenIcon"

export default {
    mixins: [profile_utilities, phase_utilities, handles_saving],
    components: {
        PhaseTitle,
        FormDateInput,
        FormInput,
        BaseButton,
        OpenIcon
    },
    mounted () {
        this.reset_record_id()
    },
    watch: {
        "record.id": "reset_record_id"
    },
    methods: {
        reset_record_id () {
            this.record_id = this.record ? this.record.id : 0
        },
        star_toggle () {
            this.save_field(!this.record.starred, "starred")
        },
        remove () {
            if(!this.active_project_editable) return

            this.$confirm({
                type: "error",
                title: "Delete Phase",
                message: `Do you really want to delete ${this.phase_standardized_title(this.record)}? Once it's gone, it's gone...`,
                cancel: "Keep It",
                ok: "Delete It",
                then: (confirmed) => {
                    if(confirmed) {
                        this.$store.dispatch("RECORD_DELETE", {
                            entity: "phase",
                            id: this.record.id
                        }).catch(error => {
                            if(error) this.$error(error.message)
                        })
                    }
                }
            })
        }
    },
    computed: {
        active_project () {
            return !!this.project && !!this.project.activated_at
        },
        active_project_editable () {
            if(this.active_project && this.is_db_admin_active) return true
            return this.editable || this.is_db_admin_active
        },
        missing_info () {
            if(!this.record) return false
            return !this.record.starts_at || !this.record.ends_at || ((this.active_project ? this.record.fee : this.record.prospective_fee) <= 0)
        }
    },
    props: {
        project: {
            type: Object,
            required: true
        },
        record: {
            type: Object,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            entity: "phase"
        }
    }
}
</script>
